// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-stub-cards {\n  height: 1px;\n}", "",{"version":3,"sources":["webpack://./src/components/stub-cards/styles.scss"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF","sourcesContent":["@import \"src/styles/common-imports.scss\";\n.c-stub-cards {\n  height: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
